import LocalDatabase from '@/includes/db';
import { Schema } from '@/includes/definitions/index.d';
import { AnkiSchedule } from '@/includes/definitions/srs';

const schema = {
  name: 'AnkiSchedule',
  keyPath: 'id',
  autoIncrement: true,
  timestamps: true,
  schema: {
    id: { unique: true },
    wordId: { unique: true },
    interval: { unique: false },
    easeFactor: { unique: false },
    repetitions: { unique: false },
    lapses: { unique: false },
    due: { unique: false },
    state: { unique: false },
  },
} as Schema;

export const AnkiScheduleModel = LocalDatabase.MakeModel<AnkiSchedule>(schema);
export default schema;
